module.exports = __webpack_public_path__ + "static/media/LT.129968dd.svg";